import { MAGAZINE, NEWSLETTERS } from "../../content/resources";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Card } from "../../ui/Card";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/**
 * The old site's `/newsletter---magazine`: the three 2018 newsletter PDFs,
 * then the "Vihangam Light" magazine block with its verbatim Jan 2020
 * description, Download, and a Subscribe link to `/contact`. English
 * only - no Hindi twin.
 */
export function NewsletterPage() {
  return (
    <Page title="Newsletter / Magazine" heading="Newsletter / Magazine">
      <Section title="Newsletter">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {NEWSLETTERS.map((n) => (
            <Reveal key={n.href}>
              <Card
                title={n.title}
                cta={{
                  label: t("en", "download"),
                  href: n.href,
                  external: true,
                }}
              >
                <p>{n.blurb}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section
        eyebrow={MAGAZINE.edition}
        title={MAGAZINE.title}
        tone="ivory-deep"
      >
        <div className="max-w-prose">
          <p className="text-ink-soft">{MAGAZINE.description}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button href={MAGAZINE.href} external>
              {t("en", "download")}
            </Button>
            <Button href={MAGAZINE.subscribeHref} variant="secondary">
              Subscribe
            </Button>
          </div>
        </div>
      </Section>
    </Page>
  );
}
